<template>
  <div class="table-form table-responsive">
    <table class="table">
      <thead>
        <tr>
          <th scope="col">Tarih</th>
          <th>Alacak</th>
          <th>Bilgi</th>
          <th>Borç</th>
        </tr>
      </thead>
      <tbody>
      <tr v-for="row in paymentView.agencyPaymentViewRows" :key="row.id">
        <th style="padding: 0px !important;">
<!--          <div v-if="row.type == 'expense'">-->
            {{ row.date | ddMMyyyyHHmm}}
<!--          </div>-->

        </th>
        <th style="padding: 0px !important;">
          <div v-if="row.type == 'expense'">
            <span class="clickable-text" @click="goToReference(row)" style="font-weight: normal">{{ row.description }} </span> / <span>{{ row.amount | toCurrency }}</span>
          </div>
        </th>
        <th style="padding: 0px !important;">
          <div v-if="row.type == 'info'">
            <span class="clickable-text" @click="goToReference(row)" style="font-weight: normal">{{ row.description }} </span> / <span>{{ row.amount | toCurrency }}</span>
          </div>
        </th>
        <th style="padding: 0px !important;">
          <div v-if="row.type == 'income'">
            <span style="font-weight: normal">{{ row.description }} </span> / <span>{{ row.amount | toCurrency }}</span>
          </div>
        </th>
      </tr>
      <tr style="margin-top: 10px">
        <th style="padding: 0px !important;">
        </th>
        <th style="padding: 0px !important;">
         Alacak Toplam : {{ paymentView.expense | toCurrency }}
        </th>
        <th style="padding: 0px !important;">
          Bakiye : {{ paymentView.balance | toCurrency }}
        </th>
        <th style="padding: 0px !important;">
          Borç Toplam : {{ paymentView.income | toCurrency }}
        </th>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import ReservationStatus from "../common/ReservationStatus";
export default {
  name: "AgencyPaymentViewList",
  components: {ReservationStatus},
  props : {
    paymentView: null,
  },
  computed:{
    basePath:{
      get(){
        return this.$store.getters.getBasePath
      }
    }
  },
  methods:{
    goToReference(row){
      switch (row.entryType){
        case 'booking':
          this.$router.push('/bookings/' + row.referenceId);
          break;
        case 'proforma':
        case 'invoice':
          this.$router.push('/proforma-detail/' + row.referenceId);
          break;
      }
    }
  }
}
</script>

<style scoped>

.table-form thead th {
  background-color: white;
  color: #1976d2;
}

.theme-btn{
  color: white!important;
}

.clickable-text {
  color: blue !important;
  text-decoration: underline !important;
  cursor: pointer !important;
}
</style>